import React from 'react';
import { useDocsStore } from '../../store/docsStore';
import styles from './StorageWarning.module.css';

const WarningIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={styles.icon}
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const StorageWarning: React.FC = () => {
  const storageWarning = useDocsStore((state) => state.storageWarning);
  const storageInfo = useDocsStore((state) => state.storageInfo);
  const dismissStorageWarning = useDocsStore((state) => state.dismissStorageWarning);

  if (!storageWarning || !storageInfo) {
    return null;
  }

  return (
    <div className={styles.toast}>
      <div className={styles.toastContent}>
        <WarningIcon />
        <div className={styles.message}>
          <strong className={styles.title}>Storage Almost Full</strong>
          <p className={styles.description}>
            Using {storageInfo.percentUsed.toFixed(0)}% of available storage. Some
            documents may not cache.
          </p>
        </div>
      </div>
      <button
        className={styles.closeBtn}
        onClick={dismissStorageWarning}
        aria-label="Dismiss warning"
      >
        ×
      </button>
    </div>
  );
};
